// extracted by mini-css-extract-plugin
export default {"about":"about_about__RAAuU","title":"about_title__9zgaP"};